"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaItemSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _styles = require("../../../MediaItem/styles");
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const MediaItemSkeleton = ({
  animation = 'pulse',
  position
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    isSquare: true,
    position: position,
    className: "olapic-media-sizes",
    "data-testid": getTestId(`${_constants.MEDIA_ITEM_SKELETON}-${position}`),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      variant: "rounded",
      width: "100%",
      height: "100%",
      animation: animation
    })
  });
};
exports.MediaItemSkeleton = MediaItemSkeleton;
